import React, { useEffect, useState } from 'react'
import ModalCustom from '../../modal-custom'
import { Button, Col, Form, Row, Table } from 'react-bootstrap'
import {
  createWorksAPI,
  createWorksGroupAPI
} from '../../../services/history-works'
import Error_500 from '../../error/error-500'
import Error_false from '../../error/error-false'
import { TXTSUCCESS } from '../../../Constants'
import SwalCustom from '../../../alert/swal-custom'

function ModalAddAEWork({
  setIsSave,
  have,
  isSave,
  showAE,
  setShowAE,
  dataAe,
  setDataAe,
  orgId,
  code,
  fnGetWorks
}) {
  const textError = 'Please, field your data'

  const onSubmit = async () => {
    // setIsSave(true)
    if (have) {
      const body = {
        orgId,
        code,
        historyWorks: dataAe.map((d, i) => ({
          company: d.company ?? '',
          duty: d.duty ?? '',
          fromYear: d.fromYear ?? '',
          histyReason: d.histyReason ?? '',
          histyPosition: d.histyPosition ?? '',
          toYear: d.toYear ?? ''
        })),
        isHave: have?.status_id ?? ''
      }
      createWorkGroups(body)
    } else {
      const body = {
        orgId,
        code,
        isHave: '',
        company: '',
        histyPosition: '',
        fromYear: '',
        toYear: '',
        histyReason: ''
      }
      createWorkGroups(body)
    }
  }
  // createWorksGroupAPI
  const createWorkGroups = async (body) => {
    try {
      const resp = await createWorksGroupAPI(body)
      if (!resp) return
      if (resp?.status) {
        SwalCustom({
          title: `Success!`,
          text: TXTSUCCESS,
          timer: 1500,
          showConfirmButton: false
        }).then(() => {
          fnGetWorks()
          setShowAE(false)
        })
      } else {
        Error_false(resp)
      }
      setIsSave(false)
    } catch (error) {
      Error_500(error)
      setIsSave(false)
    }
  }

  const handleDateChange = (toDoList, id) => {
    setDataAe((prev) => {
      return prev.map((d) => (d.id === id ? { ...d, ...toDoList } : d))
    })
  }
  return (
    <ModalCustom width={1200} open={showAE} onCancel={() => setShowAE(false)}>
      <h5>Number AE search results</h5>
      <Table responsive bordered hover className="mb-0">
        <thead
          className="bg-hrms text-white "
          style={{ position: 'sticky', top: '0px' }}
        >
          <tr>
            <th className="fw-normal small " rowSpan={2}>
              Company Name
            </th>
            <th className="fw-normal small " rowSpan={2}>
              Position
            </th>
            <th className="fw-normal small " rowSpan={2}>
              Job description
            </th>
            <th className="fw-normal small text-center" colSpan={2}>
              Periods
            </th>

            <th className="fw-normal small " rowSpan={2}>
              Reason for leaving
            </th>
          </tr>
          <tr>
            <th className="fw-normal small text-center">From</th>
            <th className="fw-normal small text-center">To</th>
          </tr>
        </thead>
        <tbody>
          {dataAe.length > 0 ? (
            dataAe.map((d, i) => (
              <tr key={i} className="fw-light font-small-2 ">
                <td>
                  {d.isCompany ? (
                    <span>{d.company}</span>
                  ) : (
                    <>
                      <Form.Control
                        maxLength={300}
                        value={d?.company}
                        onChange={(e) => {
                          handleDateChange({ company: e.target.value }, d.id)
                        }}
                      />
                      {!d?.company ? (
                        <div className="text-danger">{textError}</div>
                      ) : null}
                    </>
                  )}
                </td>
                <td>
                  {d.isHistoryPosition ? (
                    <span>{d.histyPosition}</span>
                  ) : (
                    <>
                      <Form.Control
                        maxLength={300}
                        value={d?.histyPosition}
                        onChange={(e) => {
                          handleDateChange(
                            { histyPosition: e.target.value },
                            d.id
                          )
                        }}
                      />
                      {!d.histyPosition ? (
                        <div className="text-danger">{textError}</div>
                      ) : null}
                    </>
                  )}
                </td>
                <td>
                  {d.isDuty ? (
                    <span>{d.duty}</span>
                  ) : (
                    <>
                      <Form.Control
                        maxLength={300}
                        value={d?.duty}
                        onChange={(e) => {
                          handleDateChange({ duty: e.target.value }, d.id)
                        }}
                      />
                      {!d.duty ? (
                        <div className="text-danger">{textError}</div>
                      ) : null}
                    </>
                  )}
                </td>
                <td className="text-center">
                  {d.isFromYear ? (
                    <span>{d.fromYear}</span>
                  ) : (
                    <>
                      <Form.Control
                        maxLength={300}
                        value={d?.fromYear}
                        onChange={(e) => {
                          handleDateChange({ fromYear: e.target.value }, d.id)
                        }}
                      />
                      {!d.fromYear ? (
                        <div className="text-danger">{textError}</div>
                      ) : null}
                    </>
                  )}
                </td>
                <td className="text-center">
                  {d.isToYear ? (
                    <span>{d.toYear}</span>
                  ) : (
                    <>
                      <Form.Control
                        maxLength={300}
                        value={d?.toYear}
                        onChange={(e) => {
                          handleDateChange({ toYear: e.target.value }, d.id)
                        }}
                      />
                      {!d.toYear ? (
                        <div className="text-danger">{textError}</div>
                      ) : null}
                    </>
                  )}
                </td>
                <td>
                  {d.isHistoryReason ? (
                    <span>{d.histyReason}</span>
                  ) : (
                    <>
                      <Form.Control
                        maxLength={300}
                        value={d?.histyReason}
                        onChange={(e) => {
                          handleDateChange(
                            { histyReason: e.target.value },
                            d.id
                          )
                        }}
                      />
                      {!d?.histyReason ? (
                        <div className="text-danger">{textError}</div>
                      ) : null}
                    </>
                  )}
                </td>
              </tr>
            ))
          ) : (
            <tr className="fw-light ">
              <td colSpan={8} className="text-center">
                - No data -
              </td>
            </tr>
          )}
        </tbody>
      </Table>
      <Row className="mt-3">
        <Col xl={12} className="text-center">
          <Button
            className="px-4 text-primary me-3"
            onClick={() => setShowAE(false)}
            variant="light"
          >
            Cancel
          </Button>
          {dataAe.length > 0 ? (
            <Button className="px-4" disabled={isSave} onClick={onSubmit}>
              {isSave ? 'Adding...' : 'Add All'}
            </Button>
          ) : (
            <Button className="px-4" disabled={true}>
              Add All
            </Button>
          )}
        </Col>
      </Row>
    </ModalCustom>
  )
}

export default ModalAddAEWork
